import api from '@/api';

import { API_BASE_URL } from '..';
import {
  CrmMatrixSettings,
  CrmMatrixSettingsUpdate,
} from './MatrixCrmSettings.types';

const CONTROLLER_URL = `${API_BASE_URL}/matrices-crm-settings`;

export async function getCrmSettingsMatrix(): Promise<CrmMatrixSettings> {
  const result = (await api.get(`${CONTROLLER_URL}/matrix`, {})) as unknown;

  return result as CrmMatrixSettings;
}

export async function getUpdateCrmMatrixSettings(obj: CrmMatrixSettingsUpdate) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${obj.id}`,
    obj,
    null,
  )) as unknown;

  return result;
}
